const enum Filter {
    None = 0,
    CustomerStatus = 1,
    Statut = 2,
    NomAZ = 3,
    NomZA = 4
}

export default Filter;